import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../../chunks/tslib.es6.js";
import { property as a } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as s } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as e } from "../../core/accessorSupport/decorators/writer.js";
import { collectField as t, collectArcadeFieldNames as o } from "../../layers/support/fieldUtils.js";
import l from "../visualVariables/ColorVariable.js";
import u from "../visualVariables/OpacityVariable.js";
import p from "../visualVariables/RotationVariable.js";
import V from "../visualVariables/SizeVariable.js";
import c from "../visualVariables/VisualVariable.js";
import n from "../visualVariables/VisualVariableFactory.js";

var b = {
  base: c,
  key: "type",
  typeMap: {
    opacity: u,
    color: l,
    rotation: p,
    size: V
  }
},
    v = function v(l) {
  var u = /*#__PURE__*/function (_l) {
    _inherits(u, _l);

    var _super = _createSuper(u);

    function u() {
      var _this;

      _classCallCheck(this, u);

      _this = _super.apply(this, arguments), _this._vvFactory = new n();
      return _this;
    }

    _createClass(u, [{
      key: "visualVariables",
      set: function set(r) {
        this._vvFactory.visualVariables = r, this._set("visualVariables", this._vvFactory.visualVariables);
      }
    }, {
      key: "readVisualVariables",
      value: function readVisualVariables(r, a, s) {
        return this._vvFactory.readVariables(r, a, s);
      }
    }, {
      key: "writeVisualVariables",
      value: function writeVisualVariables(r, a, s, i) {
        a[s] = this._vvFactory.writeVariables(r, i);
      }
    }, {
      key: "arcadeRequiredForVisualVariables",
      get: function get() {
        if (!this.visualVariables) return !1;

        var _iterator = _createForOfIteratorHelper(this.visualVariables),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _r = _step.value;
            if (_r.arcadeRequired) return !0;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return !1;
      }
    }, {
      key: "hasVisualVariables",
      value: function hasVisualVariables(r, a) {
        return r ? this.getVisualVariablesForType(r, a).length > 0 : this.getVisualVariablesForType("size", a).length > 0 || this.getVisualVariablesForType("color", a).length > 0 || this.getVisualVariablesForType("opacity", a).length > 0 || this.getVisualVariablesForType("rotation", a).length > 0;
      }
    }, {
      key: "getVisualVariablesForType",
      value: function getVisualVariablesForType(r, a) {
        var s = this.visualVariables;
        return s ? s.filter(function (s) {
          return s.type === r && ("string" == typeof a ? s.target === a : !1 !== a || !s.target);
        }) : [];
      }
    }, {
      key: "collectVVRequiredFields",
      value: function () {
        var _collectVVRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r, a) {
          var s, _iterator2, _step2, _i;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  s = [];
                  this.visualVariables && (s = s.concat(this.visualVariables));
                  _iterator2 = _createForOfIteratorHelper(s);
                  _context.prev = 3;

                  _iterator2.s();

                case 5:
                  if ((_step2 = _iterator2.n()).done) {
                    _context.next = 17;
                    break;
                  }

                  _i = _step2.value;
                  _context.t0 = _i;

                  if (!_context.t0) {
                    _context.next = 15;
                    break;
                  }

                  _i.field && t(r, a, _i.field);
                  _i.normalizationField && t(r, a, _i.normalizationField);
                  _context.t1 = _i.valueExpression;

                  if (!_context.t1) {
                    _context.next = 15;
                    break;
                  }

                  _context.next = 15;
                  return o(r, a, _i.valueExpression);

                case 15:
                  _context.next = 5;
                  break;

                case 17:
                  _context.next = 22;
                  break;

                case 19:
                  _context.prev = 19;
                  _context.t2 = _context["catch"](3);

                  _iterator2.e(_context.t2);

                case 22:
                  _context.prev = 22;

                  _iterator2.f();

                  return _context.finish(22);

                case 25:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 19, 22, 25]]);
        }));

        function collectVVRequiredFields(_x, _x2) {
          return _collectVVRequiredFields.apply(this, arguments);
        }

        return collectVVRequiredFields;
      }()
    }]);

    return u;
  }(l);

  return r([a({
    types: [b],
    value: null,
    json: {
      write: !0
    }
  })], u.prototype, "visualVariables", null), r([s("visualVariables", ["visualVariables", "rotationType", "rotationExpression"])], u.prototype, "readVisualVariables", null), r([e("visualVariables")], u.prototype, "writeVisualVariables", null), u = r([i("esri.renderers.mixins.VisualVariablesMixin")], u), u;
};

export { v as VisualVariablesMixin };